import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mt-6">
          Seite nicht gefunden
        </h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          Diese Seite existiert leider nicht.
        </p>
        <Link
          to="/"
          className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300"
        >
          <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}